import React from "react"

import VideoUpload from "./VideoUpload"

const VideoUploadTest = ({ client, testMode, videoUploadEnabled }) => (
  <div className="font-sans">
    <div className="mb-6">
      <h2 className="mb-2 text-2xl font-semibold text-gray-dark">Client Information</h2>
      <div className="rounded-lg border border-gray-light bg-gray-ultralight p-4">
        <p className="text-gray-dark">
          <strong>Name:</strong> {client.name}
        </p>
        {client.email && (
          <p className="text-gray-dark">
            <strong>Email:</strong> {client.email}
          </p>
        )}
        {client.phone && (
          <p className="text-gray-dark">
            <strong>Phone:</strong> {client.phone}
          </p>
        )}
      </div>
    </div>

    <div className="mb-6">
      <h2 className="mb-4 text-2xl font-semibold text-gray-dark">Video Upload Test</h2>

      {testMode && (
        <div className="mb-4 rounded-lg border border-orange bg-orange-light p-4">
          <p className="text-orange">
            <strong>Test Mode:</strong> You are in test mode. Videos will be uploaded to S3 and processed with
            MediaConvert.
          </p>
        </div>
      )}

      {videoUploadEnabled ? (
        <VideoUpload />
      ) : (
        <div className="rounded-lg border border-red bg-red-light p-4">
          <p className="text-red">
            <strong>Video upload is disabled.</strong> Please check your AWS configuration.
          </p>
        </div>
      )}
    </div>

    <div className="mt-8">
      <h3 className="mb-3 text-lg font-semibold text-gray-dark">Instructions:</h3>
      <ul className="list-inside list-disc space-y-2 text-gray">
        <li>Select a video file (MP4, MOV, AVI, or WebM)</li>
        <li>Maximum file size: 100MB</li>
        <li>Recommended duration: 30-60 seconds</li>
        <li>The video will be uploaded directly to S3</li>
        <li>After upload, it will be automatically transcoded to optimized MP4</li>
        <li>Check the browser console for detailed logs</li>
      </ul>
    </div>

    <div className="mt-6 rounded-lg border border-gray-light bg-gray-ultralight p-4">
      <h4 className="mb-2 font-semibold text-gray-dark">Technical Details:</h4>
      <ul className="space-y-1 text-sm text-gray">
        <li>
          <strong>Upload Path:</strong> S3 → uploads/videos/{client.id}/
        </li>
        <li>
          <strong>Processed Path:</strong> S3 → processed/videos/{client.id}/
        </li>
        <li>
          <strong>Output Format:</strong> 720p MP4 H.264/AAC
        </li>
        <li>
          <strong>Max Bitrate:</strong> 2 Mbps
        </li>
      </ul>
    </div>
  </div>
)

export default VideoUploadTest
